import Eminem from "./Assets/Eminem.PNG";
import Messi from "./Assets/Messi.PNG";
import Tramp from "./Assets/Tramp.PNG";
import Zuckerberg from "./Assets/Zuckerberg.PNG";
import Bezos from "./Assets/Bezos.PNG";
const contentItems = [
    {
        id: 1,
        image: Eminem,
        date: "August 1, 2025 — Bloomberg",
        title: "“Eminem Sells Detroit Recording Studio to Fuel HYPE Mania”",
        description: "Rap legend Marshall “Eminem” Mathers offloaded his iconic Detroit recording studio to Overfunded Fund, reinvesting every penny into HYPE tokens, calling it “the hottest beat in crypto”."
    },
    {
        id: 2,
        image: Messi, // Замените на ваш импорт изображения
        date: "August 5, 2025 — Bloomberg",
        title: "“Lionel Messi Cashes Out Barcelona Shares for Mega HYPE Wager”",
        description: "Football superstar Lionel Messi sold all of his FC Barcelona shares to Overfunded Fund, redeploying the capital into HYPE, saying “dribbling on the pitch is fun, but dribbling tokens is the future”."
    },
    {
        id: 3,
        image: Tramp, // Замените на ваш импорт изображения
        date: "August 9, 2025 — Bloomberg",
        title: "“Donald Trump Closes Mar-a-Lago, Bets Big on HYPE”",
        description: "Former President Donald J. Trump announced the closure of his Mar-a-Lago estate, selling property rights to Overfunded Fund to acquire HYPE tokens, describing it as “huge, tremendous opportunity, lots of hype”."
    },
    {
        id: 4,
        image: Zuckerberg, // Замените на ваш импорт изображения
        date: "August 18, 2025 — Bloomberg",
        title: "“Mark Zuckerberg Liquidates Meta Stake for HYPE Hyperdrive”",
        description: "Meta Platforms CEO Mark Zuckerberg offloaded a majority stake in his company to invest in HYPE, citing “more likes per token than any social network”."
    },
    {
        id: 5,
        image: Bezos, // Замените на ваш импорт изображения
        date: "August 23, 2025 — Bloomberg",
        title: "“Jeff Bezos Auctions Blue Origin Rockets to Back HYPE Launch”",
        description: "Amazon founder Jeff Bezos put his Blue Origin rockets up for auction, directing the windfall into HYPE, calling it “lifting off the only way that matters — into crypto space”."
    }
];
export default contentItems;